export const stockEndPoints = {
  getList: (queryString: string) => `/stock/list${queryString}`,
  create: () => '/stock/create',
  update: (id: string) => `/stock/update/${id}`,
};
